import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CassetteChock } from "../../models/CassetteChock";
import { getCassetteChocks } from "../../repositories/CassetteChockRepository";
import { TableCassetteChock } from "./components/TableCassetteChock";

type useCassetteChocksProps = {
	partId?: number;
	onError?: (error: Error) => void;
};

export const useCassetteChocks = ({
	partId,
	onError,
}: useCassetteChocksProps) => {
	return useQuery<CassetteChock[], Error>({
		queryKey: ["cassetteChocks", partId],
		queryFn: ({ signal }) => getCassetteChocks({ partId }, signal),
		onError: onError,
	});
};

export const CassetteChockPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Cassette Chocks" />
			<TableCassetteChock partId={partId} />
		</>
	);
};
